<template>
    <index-table
        :cols="[
            {
                value: 'name',
                label: 'Name',
                sortable: true,
                searchable: true,
            },
            {
                value: 'type',
                label: 'Organization Type',
                sortable: true,
                searchable: false,
            },
            {
                value: 'admins',
                label: 'Admins',
                sortable: false,
                searchable: true,
                display: 'email',
            },
            {
                value: 'license_hard_cap',
                label: 'Licenses Hard Cap',
                sortable: false,
                searchable: false,
            },
            {
                value: 'purchased_license_count',
                label: 'Purchased Licenses',
                sortable: false,
                searchable: false,
            },
            {
                value: 'premium_users_count',
                label: 'Active Licenses',
                sortable: false,
                searchable: false,
            },
        ]"
        :title="'Organizations'"
        :model="'organizations'"
        :createText="'Create Organization'"
        :options="['viewable', 'editable', 'deletable']"
        data-test-id="organizations-table"
    />
</template>

<script>
import IndexTable from '@/components/IndexTable/index.vue'

export default {
    components: {
        IndexTable,
    },
}
</script>
